import { NOPING_GREEN } from '../constants';

export function FooterGlow() {
  return <div className='pointer-events-none absolute inset-0' style={{ background: `radial-gradient(ellipse at bottom, ${NOPING_GREEN}08 0%, transparent 60%)` }} aria-hidden='true' />;
}
